import React, { PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { getUiConfigurationState } from 'src/app/store/config'

const ErrorText: React.FC<PropsWithChildren> = (props: any) => {
  const { children } = props
  const ui = useSelector(getUiConfigurationState)
  return <p className='error-message'>{children}</p>
}
export default ErrorText
